<template>
  <ValidationObserver v-slot="{ invalid }" tag="tr">
    <td class="form-group col-lg-4 col-md-12">{{ bonusRateDto.bonusType }}</td>
    <td v-if="isUpdateMode">
      <NumberInputField
          class="w-50 d-inline-block" v-model="updatedPercentage"
          labelText="percentage"
          noLabel/>
    </td>
    <td v-else>
      {{ bonusRateDto.percentage }}
    </td>
    <td>
      <button
          v-show="!isUpdateMode"
          style="width: 200px;"
          class="btn-basic btn-outline-pulse mr-2" @click="toggleUpdateMode">
        Percentage aanpassen
      </button>
      <button
          v-show="!isUpdateMode"
          style="width: 150px;"
          class="btn-basic btn-red" @click="removeBonusRate">
        Verwijderen
      </button>
      <button
          :disabled="isSaving || invalid" v-show="isUpdateMode"
          class="btn-basic btn-fill-pulse mr-2" @click="save">
        Opslaan
      </button>
      <button
          :disabled="isSaving" v-show="isUpdateMode"
          class="btn-basic btn-fill-pulse-dark" @click="toggleUpdateMode">
        Annuleren
      </button>
    </td>
  </ValidationObserver>
</template>

<script>
import {mapActions} from "vuex";
import {ValidationObserver} from "vee-validate";
import NumberInputField from "@/components/inputFields/NumberInputField";

export default {
  name: "EditBonusRateComponent",
  components: {
    NumberInputField,
    ValidationObserver,
  },
  props: ["bonusRateDto", "from"],
  data: () => ({
    isUpdateMode: false,
    isSaving: false,
    updatedPercentage: 0,
  }),
  created() {
    this.updatedPercentage = this.bonusRateDto.percentage;
  },
  methods: {
    ...mapActions("administrationCustomer", ["updateBonusRateFromCustomer",'fetchDetailsForSelectedCustomer', 'removeBonusRateFromCustomer']),
    toggleUpdateMode() {
      this.updatedPercentage = this.bonusRateDto.percentage;
      this.isUpdateMode = !this.isUpdateMode;
    },
    removeBonusRate() {
      if (confirm("Weet u zeker dat u het volgende bonustarief wilt verwijderen voor deze klant: " + this.bonusRateDto.bonusType + "?")) {
        const bonusType = this.bonusRateDto.bonusType;
        const percentage = this.bonusRateDto.percentage;
        const updateBonusRateDto = {
          bonusType, percentage
        };
        this.removeBonusRateFromCustomer(updateBonusRateDto);
      }
    },
    resetFields() {
      this.updatedPercentage = this.bonusRateDto.percentage;
    },
    async save() {
      this.isSaving = true;
      const bonusType = this.bonusRateDto.bonusType;
      const percentage = this.updatedPercentage;
      const updateBonusRateDto = {
        bonusType, percentage
      };
      await this.updateBonusRateFromCustomer(updateBonusRateDto)
          .then(() => {
            this.isSaving = false;
            this.isUpdateMode = false;
            this.resetFields();
            this.fetchDetailsForSelectedCustomer();
          }).catch(() => {
            this.isSaving = false;
            this.isUpdateMode = false;
          });
    },
  }
};
</script>